import { MoonLoader } from 'react-spinners';

type SpinnerProps = {
    color?: string;
    loading?: boolean;
    className?: string;
    speedMultiplier?: number;
};

function SmallSpinner({ color = '#2970ff', loading = true, className, speedMultiplier = 1 }: SpinnerProps) {
    return (
        <MoonLoader
            size={10}
            color={color}
            loading={loading}
            speedMultiplier={speedMultiplier}
            className={className}
        />
    );
}

export default SmallSpinner;
